import React from "react";
import "antd/dist/antd.css";
import { Button, Col, Row, Space, Popover } from "antd";
// import SignatureDetailsModal from "../../SignatureDetailsModal/index";
import SignatureMissingPopup from "../../SignatureMissingPopup/index";
import SignatureAllPopup from "../../SignatureAllPopup/index";
import ReportIcon from "../../../../../assets/report.png";
import CommonConfig from "../../../../commonConfig.json";
import * as actions from "../../../../../store/actions/indexes";
import "../common.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

let compliancePopupDetail = CommonConfig.compliancePopupDetail;
let clickOrigin = CommonConfig.clickOrigin;

let cellType = CommonConfig.cellType;

class SignatureCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.idKey,
      sigMissingPopUpRight: false,
      sigAllPopUpRight: false,
    };
  }

  getCellType = (key) => {
    return cellType[key] || "TEXT";
  };

  signatureDetaislPopUp(origin) {
    this.props.setSignatureModalData({
      signContnent: this.props.signContnent,
      signStatus: this.props.status,
      basicCellData: this.props.basicCellData,
      visible: this.state.signatureDetailsPopUpVisible,
      onHide: this.hideOnTrigger,
      origin: origin,
    });
  }

  signatureMissingRightPopUp() {
    this.setState({ sigMissingPopUpRight: !this.state.sigMissingPopUpRight });
  }

  signatureAllRightPopUp() {
    this.setState({ sigAllPopUpRight: !this.state.sigAllPopUpRight });
  }

  onHide = (val) => {
    this.setState({
      sigMissingPopUpRight: val,
      sigAllPopUpRight: val,
    });
  };

  render() {
    if (this.props.status.nonCompliant) {
      this.state.sigMissingPopUpRight = false;
      this.state.sigAllPopUpRight = false;
    }

    let signRatio = this.props.status.signedRatio.split("/");
    let upRatio = this.props.status.sigUploadedRatio.split("/");
    let temp = [];
    if (this.props.status.signedRatio !== "0/0") {
      temp[0] = parseInt(signRatio[0]);
      temp[1] = parseInt(signRatio[1]);
    } else {
      temp[0] = parseInt(upRatio[0]);
      temp[1] = parseInt(upRatio[1]);
    }

    let showSig =
      this.props.status.signedRatio !== "0/0" &&
      (this.props.status.showSignCount === undefined ||
        (this.props.status.showSignCount !== undefined &&
          this.props.status.showSignCount === true)) &&
      this.props.compSignNumberShowHide;

    let cellFiller = "";
    if (
      [
        "TEXT",
        "EXPIRED",
        "HOTEL_TZ_NOT_REACHED",
        "HOTEL_NOT_LIVE",
        "HOTEL_SOFT_LIVE",
        "HOTEL_SIG_NOT_LIVE",
        "AWAITING_SIG_TRIGGER",
      ].includes(this.getCellType(this.props.status.type))
    ) {
      cellFiller = (
        <span
          style={{
            color:
              this.props.status.style.color !== undefined
                ? this.props.status.style.color
                : "white",
            textAlign: "center",
          }}
        >
          {this.props.status.text !== undefined ? this.props.status.text : ""}
        </span>
      );
    } else {
      cellFiller = (
        <Button
          onClick={() => this.signatureDetaislPopUp(clickOrigin.BUTTON)}
          type="primary"
          size="small"
          style={{
            fontSize: "12px",
            whiteSpace: "break-spaces",
            height: "auto",
          }}
          block
        >
          {this.props.status.text !== undefined ? this.props.status.text : ""}
        </Button>
      );
    }

    let centerComponent = "";
    if (this.props.status.tooltip !== undefined) {
      if (this.props.status.plainCell === undefined) {
        centerComponent = (
          <Col className="cell-middle-content" span={18}>
            <Col>
              <Popover
                className="cellPointer"
                content={this.props.status.tooltip}
                title=""
                placement="top"
                trigger="click"
                arrowPointAtCenter
              >
                {cellFiller}
              </Popover>
            </Col>
          </Col>
        );
      } else {
        centerComponent = (
          <Popover
            className="cellPointer"
            content={this.props.status.tooltip}
            title=""
            placement="top"
            trigger="click"
            arrowPointAtCenter
          >
            <Col className="cell-middle-content plain-cell" span={22}>
              <Col>{cellFiller}</Col>
            </Col>
          </Popover>
        );
      }
    } else {
      if (this.props.status.plainCell !== undefined) {
        centerComponent = (
          <Col className="cell-middle-content plain-cell" span={22}>
            <Col>{cellFiller}</Col>
          </Col>
        );
      } else {
        centerComponent = (
          <Col className="cell-middle-content" span={18}>
            <Col>{cellFiller}</Col>
          </Col>
        );
      }
    }
    let uploadedCount = parseInt(
      this.props.status.sigUploadedRatio.split("/")[0]
    );
    let leftComponent = (
      <Col className="cell-start-content" span={3}>
        <Space direction="vertical">
          <Row>
            <Col span={24}>
              {uploadedCount > 0 && this.props.compMyDocsNav ? (
                <span
                  onClick={() => {
                    window.open(this.props.mydocsURL, "_blank");
                  }}
                  className="cellPointer"
                >
                  <img
                    src={ReportIcon}
                    className="reportIcon"
                    alt="reportIcon"
                  />
                </span>
              ) : (
                <>&nbsp;</>
              )}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div
                className="cellPointer reportCount"
                onClick={() => {
                  if (showSig) {
                    this.signatureDetaislPopUp(clickOrigin.RATIO);
                  }
                }}
              >
                {showSig ? this.props.status.signedRatio : <></>}
              </div>
            </Col>
          </Row>
        </Space>
      </Col>
    );
    let rightComponent = (
      <Col className="cell-end-content" span={3}>
        <Space direction="vertical">
          <Row>
            <Col span={24}>
              <div>&nbsp;</div>
            </Col>
          </Row>
          <Row>
            {this.props.compSignReportsPopupDetails ===
            compliancePopupDetail.ALL ? (
              <Col span={24} onClick={() => this.signatureAllRightPopUp()}>
                <SignatureAllPopup
                  reportContent={this.props.reportContent}
                  visible={this.state.sigAllPopUpRight}
                  onHide={this.onHide}
                  bdate={this.props.idKey.split(":")[1]}
                  hname={
                    this.props.idKey.split(":")[0] !== "" &&
                    this.props.idKey.split(":")[3] !== ""
                      ? this.props.idKey.split(":")[3] +
                        " - " +
                        this.props.idKey.split(":")[0]
                      : this.props.idKey.split(":")[2] === "Generic"
                      ? this.props.idKey.split(":")[0]
                      : this.props.idKey.split(":")[3]
                  }
                  // visible={signaturePopupStatus.sigAllPopUpRight }
                  innerContent={
                    <div className="cellPointer reportCount">
                      {this.props.status.sigUploadedRatio}
                    </div>
                  }
                />
              </Col>
            ) : this.props.reportContent.mis_reports.find(
                (report) =>
                  (report.type = "missing" && report.signatureRequired)
              ) ? (
              <Col span={24} onClick={() => this.signatureMissingRightPopUp()}>
                <SignatureMissingPopup
                  reportContent={this.props.reportContent}
                  visible={this.state.sigMissingPopUpRight}
                  onHide={this.onHide}
                  bdate={this.props.idKey.split(":")[1]}
                  hname={
                    this.props.idKey.split(":")[0] !== "" &&
                    this.props.idKey.split(":")[3] !== ""
                      ? this.props.idKey.split(":")[3] +
                        " - " +
                        this.props.idKey.split(":")[0]
                      : this.props.idKey.split(":")[2] === "Generic"
                      ? this.props.idKey.split(":")[0]
                      : this.props.idKey.split(":")[3]
                  }
                  // visible={signaturePopupStatus.sigMissingPopUpRight }
                  innerContent={
                    <div className="cellPointer reportCount">
                      {this.props.status.sigUploadedRatio}
                    </div>
                  }
                />
              </Col>
            ) : (
              <Col span={24}>
                <div style={{ color: "white" }}>
                  {this.props.status.sigUploadedRatio}
                </div>
              </Col>
            )}
          </Row>
        </Space>
      </Col>
    );

    if (this.props.status.plainCell !== undefined) {
      leftComponent = (
        <Col className="cell-start-content" span={1}>
          <Space direction="vertical">
            <Row>
              <Col span={24}>
                <div style={{ height: "21px" }}></div>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <div style={{ height: "21px" }}></div>
              </Col>
            </Row>
          </Space>
        </Col>
      );
      rightComponent = (
        <Col className="cell-start-content" span={1}>
          <Space direction="vertical">
            <Row>
              <Col span={24}>
                <div style={{ height: "21px" }}></div>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <div style={{ height: "21px" }}></div>
              </Col>
            </Row>
          </Space>
        </Col>
      );
    }

    let cellGradient = {
      height: "50px",
      backgroundColor: this.props.status.style["background-color"],
    };
    if (!isNaN(temp[0] / temp[1])) {
      cellGradient["backgroundImage"] = `linear-gradient(to right, #338E4D ${
        (temp[0] / temp[1]) * 100
      }%, ${this.props.status.style["background-color"]} ${
        (temp[0] / temp[1]) * 100
      }%)`;
    }
    if (
      this.props.status.gradient !== undefined &&
      this.props.status.gradient === false
    ) {
      delete cellGradient.backgroundImage;
    }

    return (
      <div>
        <Row style={cellGradient}>
          {leftComponent}
          {centerComponent}
          {rightComponent}
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let compPermissions = state.appPermissionsReducer.compliancePermissions;
  return {
    compSignReportsPopupDetails: compPermissions.compSignReportsPopupDetails,
    compSignNumberShowHide: compPermissions.compSignNumberShowHide,
    compMyDocsNav: compPermissions.compMyDocsNav,
    sigPopupVisibility: state.signatureDetailsPopupReducer.sigPopupVisibility,
    // popupStatus: state.popupStatusReducer.popupStatus,
    // cellId: state.popupStatusReducer.cellId,
    // popupType: state.popupStatusReducer.type,
    // popupConfig: state.popupStatusReducer.popupConfig,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleSignatureModalVisibility: actions.toggleSignatureModalVisibility,
      setSignatureModalData: actions.setSignatureModalData,
      // setPopupOpen : actions.setPopupOpen,
      // setPopupMatrixStatus : actions.setPopupMatrixStatus,
    },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(SignatureCell);
